(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["margalo-video-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('margalo-video-carousel')) {
  customElements.define('margalo-video-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.margalo-editable-video-grid');
      this.previous = this.querySelector('[data-video-prev]');
      this.next = this.querySelector('[data-video-next]');
      if (!this.track) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.previous) this.previous.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
      };
      const move = direction => {
        const card = this.track.querySelector('.margalo-editable-video-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      if (this.previous) this.previous.addEventListener('click', () => move(-1), options);
      if (this.next) this.next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', update, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, options);
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.track);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
